/* eslint-disable import/prefer-default-export */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import ModelState from "../../../types/musicData";

interface value {
  value: boolean;
}

interface UIState {
  color: boolean;
  texture: boolean;
  isRotating: boolean;
  renderPreview: boolean;
}

const initialState: UIState = {
  color: false,
  texture: false,
  isRotating: false,
  renderPreview: false,
};

export const appData = createSlice({
  name: "musicPlaying",
  initialState,
  reducers: {
    showColor: (state) => {
      state.texture = false;
      state.color = !state.color;
    },
    showTexture: (state) => {
      state.color = false;
      state.texture = !state.texture;
    },
    setInitial: (state) => {
      state = {
        color: false,
        texture: false,
        isRotating: false,
        renderPreview: false,
      };
    },
    setRenderPreview: (state, action: PayloadAction<any>) => {
      state.renderPreview = action.payload;
    },
  },
});

export const { showColor, showTexture, setInitial, setRenderPreview } =
  appData.actions;

export default appData.reducer;
